import { render, staticRenderFns } from "./infoIndexLoudShnepi.vue?vue&type=template&id=d2684c98&scoped=true"
import script from "./infoIndexLoudShnepi.vue?vue&type=script&lang=js"
export * from "./infoIndexLoudShnepi.vue?vue&type=script&lang=js"
import style0 from "./infoIndexLoudShnepi.vue?vue&type=style&index=0&id=d2684c98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2684c98",
  null
  
)

export default component.exports